// extracted by mini-css-extract-plugin
export default {"base":"vp_AlFFh","item":"vp_cDGOU"};